import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getMyPlans } from "../slice/workerPlansSlice";
import { Link, useLocation, useNavigate, Navigate } from "react-router-dom";

const WorkerPlans = () => {
    const dispatch = useDispatch();

    const { workerPlansData, loading, error } = useSelector(
        (state) => state.workerPlansSlice
    );

    const token = localStorage.getItem("token");
    useEffect(() => {
        if (!token) return;
        dispatch(getMyPlans(token));
    }, [token, dispatch]);

    console.log("workerPlansData", workerPlansData);


    return (
        <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
            <div className="ps-2 ps-lg-4">
                <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
                    My Plans
                </h4>

                {/* LOADING */}
                {loading && <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "60vh" }}>
                    <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div>
                </div>}

                {/* ERROR */}
                {error && <p className="text-danger">{error}</p>}

                {workerPlansData.length === 0 ? (
                    <>
                        <div className="col-md-12">
                            <div className="card p-2 shadow-sm">
                                <div class="pmpro_card_actions">
                                    <span class="pmpro_card_action">
                                        {/* <a id="pmpro_actionlink-change" href="{worker-allplans}" class="">Change</a> */}
                                        <Link className="btn btn-light-header font-weight-medium rounded" to="/worker-allplans">Purchase Plan</Link>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="text-center py-5">
                            <h5 className="text-muted">No Plan Available</h5>
                        </div>
                    </>
                ) :
                    (
                        <>
                            <div className="col-md-12">
                                <div className="card p-2 shadow-sm">
                                    <h3>{workerPlansData.current_plan.plan_name}</h3>
                                    <p>{workerPlansData.current_plan.plan_description}</p>
                                    <div class="pmpro_card_actions">
                                        <span class="pmpro_card_action">
                                            {/* <a id="pmpro_actionlink-change" href="{worker-allplans}" class="">Change</a> */}
                                            <Link className="btn btn-light-header font-weight-medium rounded" to="/worker-allplans">Change</Link>
                                        </span>
                                        <span class="pmpro_card_action px-2">
                                            <a id="pmpro_actionlink-cancel" href="https://dev.4ncaf.org/membership-account/membership-cancel/?levelstocancel=2" class="btn btn-light-header font-weight-medium rounded">Cancel</a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            {workerPlansData.old_plans.length === 0 ? (
                       
                        <>
                        <div className="text-center py-5">
                            <h5 className="text-muted">No Plan History Available</h5>
                        </div>
                        </>


                            ) :
                    (
 <>    
                            <div className="col-md-12 pt-3">

                                <h3>Plans History</h3>

                                <table class="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">#ID</th>
                                            <th scope="col">Plan Name</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Start Date</th>
                                            <th scope="col">End Date</th>
                                            <th scope="col">Payment Status</th>
                                            <th scope="col">Membership Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            workerPlansData.old_plans.map((plan) => {
                                                return (
                                                    <tr>
                                                        <th scope="row">{plan.id}</th>
                                                        <td>{plan.plan_name}</td>
                                                        <td>{plan.amount}</td>
                                                        <td>{plan.start_date}</td>
                                                        <td>{plan.end_date}</td>
                                                        <td>{plan.payment_status}</td>
                                                        <td>{plan.membership_status}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>

                            </div>
                            </>


                    )
                }
                        </>
                    )
                }
            </div>
        </div>
    );
};

export default WorkerPlans;
